/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/SignIn/Widgets/TextField';

export default function PhoneNumberField({ value, onChange }) {
  return (
    <TextField
      title="聯絡電話"
      autoComplete="off"
      type="tel"
      name="tel"
      id="tel"
      pattern="(\d{2,3}-?|\(\d{2,3}\))\d{3,4}[- ]?\d{4}|09\d{2}(\d{6}|[ -]\d{3}[ -]\d{3})"
      value={value}
      onChange={onChange}
    />
  );
}

PhoneNumberField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

PhoneNumberField.defaultProps = {
  value: '',
  onChange: () => {},
};
